var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitClipBoardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 13 12",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5437 0C9.92239 1.1727e-06 10.286 0.159874 10.5546 0.44102L12.5795 2.56266C12.8476 2.84397 12.9999 3.22478 13 3.62144V10.4994C13 11.3275 12.3589 11.9999 11.5686 12H5.84302C5.05267 12 4.41162 11.3274 4.41162 10.4994V1.4998C4.41176 0.671749 5.05275 0 5.84302 0H9.5437ZM11.3195 4.73585C11.1151 4.51591 10.776 4.51271 10.5681 4.72685L8.31384 7.05305L7.37122 6.08182C7.16598 5.87019 6.83286 5.87019 6.62775 6.08182C6.42261 6.29334 6.42255 6.63689 6.62775 6.84849L7.94092 8.20265C8.14614 8.41414 8.47927 8.41412 8.68439 8.20265L11.3044 5.5017C11.5077 5.29192 11.5184 4.95005 11.3195 4.73585Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84192 0.747852V1.98827C3.36932 2.0789 3.19517 2.36392 3.16431 2.83513L3.16748 9.23606C3.1812 9.64025 3.45529 9.9421 3.84113 9.99864L3.84192 11.3053C3.83712 11.3053 3.4707 11.3046 3.25317 11.2055C2.70236 10.9544 2.23843 10.5335 2.01141 9.96427C1.93499 9.77265 1.89875 9.56675 1.89874 9.35961V2.53075C1.89891 1.77851 2.5069 1.02236 3.24127 0.782217C3.40908 0.727372 3.83589 0.747555 3.84192 0.747852Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960083 2.04309C1.0494 2.0282 1.1384 2.01925 1.22748 2.05128C1.24635 2.05813 1.26645 2.07821 1.26874 2.08073V9.92991C1.26442 9.93114 1.20946 9.94697 1.20923 9.94709C0.58764 10.0396 0.039267 9.49567 0 8.85231V3.24178C0.0551167 2.69563 0.401794 2.13651 0.960083 2.04309Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitClipBoardCheck);
export default __webpack_public_path__ + "static/media/aitClipBoardCheck.77dbb02423c5dc394db2ecd0c87c9702.svg";
export { ForwardRef as ReactComponent };